module.exports = __webpack_public_path__ + "bdf3bd972d8b9c8334b49237bfd4e4bf.png";